<template>
  <job-published-pasts
    data-test="job-published-pasts"
    title="過去の求人情報プレビュー"
    component-name="job-published-job"
    :recent-past-objects="recentPastJobs"
    :past-objects="pastJobs"
  >
    <template #head>
      <tr data-test="head">
        <th class="boss-table-head-center">
          求人ID
        </th>
        <th class="boss-table-head-center">
          管理用求人名
        </th>
        <th class="boss-table-head-center">
          求人名
        </th>
        <th class="boss-table-head-center">
          掲載期間
        </th>
        <th class="boss-table-head-center">
          掲載サイズ
        </th>
        <th class="boss-table-head-center">
          プレビュー
        </th>
      </tr>
    </template>
  </job-published-pasts>
</template>

<script>
import JobPublishedPasts from '@/components/organisms/JobPublishedPasts'

export default {
  components: {
    JobPublishedPasts
  },
  props: {
    recentPastJobs: {
      type: Array,
      required: true
    },
    pastJobs: {
      type: Array,
      required: true
    }
  }
}
</script>
